import script from "./UnlockAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnlockAmount.vue?vue&type=script&setup=true&lang=ts"

import "./UnlockAmount.vue?vue&type=style&index=0&id=5acc4392&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acc4392"]])

export default __exports__